import React from 'react'
import cx from 'classnames'

import s from './Round.scss'


const Round = ({ color = 'green' }) => (
  <div className={cx(s.ripple, { [s[color]]: color })}>
    <div />
    <div />
  </div>
)


export default Round
